<mat-dialog-content>
  <div class="message">セッションが切断されました。 <br />再ロードしてください。</div>
  <div class="button-container">
    <button mat-raised-button (click)="onOK()" class="relogin-btn">再ロード</button>
  </div>
</mat-dialog-content>
